import React from 'react';
import PropTypes from 'prop-types';

export function PaginationButton({ 'aria-disabled': ariaDisabled = null, children = null, disabled = false, ...rest }) {
  const isDisabled = disabled || ariaDisabled === true || ariaDisabled === 'true';

  return (
    <button type="button" {...rest} disabled={isDisabled}>
      {children}
    </button>
  );
}

PaginationButton.propTypes = {
  'aria-disabled': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  children: PropTypes.node,
  disabled: PropTypes.bool,
};
